interface UseScrollToCenterOptions {
    behavior?: ScrollBehavior;
    delay?: number;
}

export function useScrollToCenter( options: UseScrollToCenterOptions = {} ) {
    const { behavior = "smooth", delay = 0 } = options;

    const scrollToCenter = ( element: HTMLElement, container: HTMLDivElement ) => {
        const containerWidth = container.clientWidth;
        const elementLeft = element.offsetLeft;
        const elementWidth = element.offsetWidth;

        const scrollPosition = elementLeft + elementWidth / 2 - containerWidth / 2;
        const maxScroll = container.scrollWidth - containerWidth;
        const finalScroll = Math.max( 0, Math.min( scrollPosition, maxScroll ) );

        container.scrollTo( { left: finalScroll, behavior } );
    };

    const handleScroll = ( e: React.MouseEvent<HTMLElement> ) => {
        const element = e.currentTarget;
        const scrollContainer = element.closest( ".overflow-x-auto" ) as HTMLDivElement;

        if ( scrollContainer ) {
            if ( delay > 0 ) {
                setTimeout( () => scrollToCenter( element, scrollContainer ), delay );
            } else {
                scrollToCenter( element, scrollContainer );
            }
        }
    };

    return { scrollToCenter, handleScroll };
}
